import { GetPostDetailsByIdQuery_getPostDetailsById } from "@bakbak/controller";
import { Avatar, Card, List } from "antd";
import * as React from "react";
import { VoteComponent } from "../../shared/VoteComponent";

interface Props {
  post: GetPostDetailsByIdQuery_getPostDetailsById;
  loggedUser: any;
  postVoteChange: (
    likeDislike: number,
    post: GetPostDetailsByIdQuery_getPostDetailsById
  ) => void;
}

const { Meta } = Card;

export class PostDetailsHeaderView extends React.PureComponent<Props> {
  onVoteChange = async (newVoteValue: number) => {
    this.props.postVoteChange(newVoteValue, this.props.post);
  }

  render() {
    const { post, loggedUser } = this.props;
    return (
      <Card key={post.id}>
        <Meta
          avatar={
            <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
          }
          title={post.title}
          description={post.details}
        >
          <div>By: {post.author.userName}</div>
        </Meta>
        <List.Item style={{ marginTop: 5 }} />
        <div style={{ marginLeft: 50 }}>
          <VoteComponent
            data={post}
            loggedUser={loggedUser}
            dataVoteChange={this.onVoteChange}
          />
        </div>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/post/details/PostDetailsHeaderView.tsx